import React, { Component } from "react";
import {
  DataGrid,
  GridColumn,
  Panel,
  LinkButton,
  ComboBox,
  TextBox,
} from "rc-easyui";
import PropTypes from "prop-types";
import { API_URL } from "../../../constants";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { isEmpty } from "../../../helpers";
// import { Button } from "reactstrap";
const axios = require("axios");

export default class ViewMarketingAgent extends Component {
  constructor(props) {
    super(props);
    this.refereshData = this.refereshData.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.searchFieldOnChange = this.searchFieldOnChange.bind(this);

    this.state = {
      data: [],
      pageOptions: {},
      searchparam: {
        agenttype: "",
        agentname: "",
        address: "",
        marketingarea: "",
        profitsharingterms: "",
        contactno: "",
      },
    };
  }

  static propTypes = {
    selectedRow: PropTypes.object,
    OnEditClick: PropTypes.func,
    onSelectionChange: PropTypes.func,
    permissions: PropTypes.array,
  };

  componentDidMount() {
    this.setState(
      {
        pageOptions: {
          loading: true,

          pageOptions: {
            pageNumber: 1,
            pageSize: 10,
            layout: [
              "list",
              "sep",
              "first",
              "prev",
              "next",
              "last",
              "sep",
              "refresh",
              "sep",
              "manual",
              "info",
            ],
          },
        },
      },
      () => {
        this.refereshData();
      }
    );
  }

  async refereshData() {
    const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
    const {
      agentname,
      agenttype,
      address,
      marketingarea,
      profitsharingterms,
      contactno,
    } = this.state.searchparam;
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };
    var url = `${API_URL}api/getmarketingagentforpagination?rows=${pageSize}&page=${pageNumber}&agenttype=${agenttype}&agentname=${agentname}&address=${address}&marketingarea=${marketingarea}&profitsharingterms=${profitsharingterms}&rolesandrespons=&contactno=${contactno}&officecontact=&panno=&contactpersonname`;
    // getmarketingagentforpagination?agenttype=o&agentname=&address=&marketingarea=&profitsharingterms=&rolesandrespons=&contactno=&officecontact=&panno=&contactpersonname=&rows=1&page=
    // var url = API_URL + "api/priceplanspagination?row=10&page=0";

    if (access_token != null) {
      axios
        .get(url, axiosConfig)
        .then((response) => {
          var data = response.data.rows;
          if (response.status === 200) {
            this.setState({
              data: data,
              pageOptions: {
                pageOptions: {
                  pageSize: Math.min(10, 50, 30, 100, data.length),
                  total: response.data.total,
                  pageList: [10, 50, 30, 100, data.length].sort(function (
                    a,
                    b
                  ) {
                    return a - b;
                  }),
                  ...this.state.pageOptions.pageOptions,
                },
                loading: false,
              },
            });
          } else {
            this.setState({
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          }
        })
        .catch((error) => {
          this.setState({
            pageOptions: {
              pageOptions: {
                ...this.state.pageOptions.pageOptions,
              },
              loading: false,
            },
          });
        });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.refereshData();
      }
    }
  }
  async deleteRow() {
    this.setState({
      isLoading: true,
    });
    let token = getCookie("access_token");
    this.messager.confirm({
      title: "Confirm",
      msg: "Are you want to delete this?",
      result: async (r) => {
        if (r) {
          if (JSON.stringify(token) === "null") {
            const resp = await getAccessToken();
            if (resp) {
              this.deleteRoleData(this.props.selectedRow.id);
            }
          } else {
            this.deleteRoleData(this.props.selectedRow.id);
          }
        }
      },
    });
  }

  deleteRoleData(id) {
    let tokenType = getCookie("token_type");
    let token = getCookie("access_token");
    let apiUrl = `${API_URL}api/priceplan/${id}`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    let self = this;
    axios
      .delete(apiUrl, headersConfig)
      .then(function (response) {
        //console.log("response", response);
        if (response.status === 200) {
          if (response.data !== "") {
            if (response.data.status === true) {
              self.setState({
                isLoading: false,
              });
              alert(`${response.data.message}`);
              self.refereshData();
            } else {
              self.setState({
                isLoading: false,
              });
              alert(`${response.data.message}`);
            }
          } else {
            alert("Internal Server Error!!");
          }
        }
      })
      .catch(function (error) {
        //console.log("error", error);
        let response = error["response"];
        if (response !== undefined) {
          if (response.status === 400) {
            var message = "";
            response.data.errors.forEach((row, i) => {
              message +=
                "<p style='margin-bottom:3px;'>" + row.defaultMessage + "</p>";
            });
            alert(message);
          } else {
            alert("Uncaught Error");
          }
        } else {
          alert("Internal Server Error");
        }
        self.setState({
          isLoading: false,
        });
      });
  }
  onPageChange(event) {
    delete event["refresh"];
    delete event["filterRules"];
    //console.log(event);
    this.setState(
      {
        pageOptions: {
          pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
          loading: true,
        },
      },
      function () {
        this.getAllPricePlan();
      }
    );
    // if (event["refresh"]) {

    // } else {
    //   delete event["referesh"];
    //   delete event["filterRules"];
    //   this.setState(
    //     {
    //       pageOptions: {
    //         pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
    //       },
    //     },
    //     function () {
    //       this.refereshData();
    //     }
    //   );
    // }
  }
  searchFieldOnChange(name, e) {
    let searchparam = Object.assign({}, this.state.searchparam);
    searchparam[name] = e;
    this.setState({ searchparam: searchparam });
  }

  render() {
    const searchparam = this.state.searchparam;
    return (
      <div>
        {/* <Messager ref={(ref) => (this.messager = ref)}></Messager> */}
        <Panel
          title="Marketing Agent List"
          bodyStyle={{ padding: 0 }}
          style={{ height: 570 }}
        >
          <DataGrid
            data={this.state.data}
            style={{ height: 538 }}
            selectionMode="single"
            {...this.state.pageOptions}
            pagination
            {...this.props.selectedRow}
            onSelectionChange={(selection) =>
              this.props.onSelectionChange(selection)
            }
            onPageChange={this.onPageChange}
            toolbar={({ editingItem }) => (
              <div style={{ padding: 4 }}>
                <b>Agent Type</b>&nbsp;
                <ComboBox
                  data={[
                    { value: "organization", text: "Organization" },
                    { value: "individual", text: "Individual" },
                  ]}
                  valueField="value"
                  textField="text"
                  value={searchparam.agenttype}
                  onChange={(e) => this.searchFieldOnChange("agenttype", e)}
                ></ComboBox>
                &nbsp;&nbsp;
                <b>Agent Name </b>&nbsp;
                <TextBox
                  value={searchparam.agentname}
                  style={{ width: 200 }}
                  onChange={(e) => this.searchFieldOnChange("agentname", e)}
                ></TextBox>
                &nbsp;
                <b>Contact </b>&nbsp;
                <TextBox
                  value={searchparam.contactno}
                  style={{ width: 200 }}
                  onChange={(e) => this.searchFieldOnChange("contactno", e)}
                ></TextBox>
                &nbsp;
                <LinkButton
                  iconCls="icon-search"
                  plain
                  onClick={this.refereshData}
                >
                  Search
                </LinkButton>
                {this.props.permissions.includes(
                  "user-registration-edit"
                ) ? (
                  <LinkButton
                    iconCls="icon-edit"
                    plain
                    disabled={isEmpty(this.props.selectedRow)}
                    onClick={this.props.OnEditClick}
                  >
                    Edit
                  </LinkButton>
                ) : (
                  ""
                )}
              </div>
            )}
          >
            <GridColumn
              field="rn"
              align="center"
              width="30px"
              cellCss="datagrid-td-rownumber"
              render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
            />

            <GridColumn
              width={150}
              field="agentType"
              title="Agent Type"
            ></GridColumn>
            <GridColumn
              width={180}
              field="agentName"
              title="Agent Name"
            ></GridColumn>

            <GridColumn
              width={290}
              field="address"
              title="Address"
            ></GridColumn>
            <GridColumn
              width={200}
              field="panNo"
              title="PAN/VAT no"
            ></GridColumn>
            <GridColumn
              width={150}
              field="contactNo"
              title="Contact No"
            ></GridColumn>
            <GridColumn
              width={150}
              field="marketingArea"
              title="Marketing Area"
            ></GridColumn>
          </DataGrid>
        </Panel>
      </div>
    );
  }
}
